import React, { useEffect, useRef, useState } from "react";
import userAPI from "../api/UserApi";

function ImageUploader({ type, label, value, onUploadSuccess, assetType = null, }) {
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (value !== preview) {
      setPreview(value || null);
    }
  }, [value]);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowed = ["image/jpeg", "image/png", "image/jpg"];
    const max = 2 * 1024 * 1024;

    if (!allowed.includes(file.type)) {
      //   showError("Only JPG, PNG, JPEG allowed");
      return;
    }

    if (file.size > max) {
      //   showError("File must be below 2MB");
      return;
    }

    // Preview
    const reader = new FileReader();
    reader.onloadend = () => setPreview(reader.result);
    reader.readAsDataURL(file);

    try {
      setUploading(true);
      console.log("uploading file", file);
      const files = {
        assetType,
        name: `${type}.${file.type.split("/")[1]}`,
        mimeType: file.type,
        size: file.size,
      };

      console.log("uploading file data", file);
      // 1. Get presigned URL
      const res = await userAPI.uploadFile({ files: [files] });
      console.log("check responise", res);

      const responsesOfFiles = res.data;

      await Promise.all(
        responsesOfFiles.map(async (img, index) => {
          const uploadUrl = img.uploadUrl;
          const key = img.assetUrl;

          // AWS S3 upload
          const uploadResponse = await fetch(uploadUrl, {
            method: "PUT",
            headers: {
              "Content-Type": file.type,
            },
            body: file,
          });
          console.log(uploadResponse);
          console.log(uploadResponse.status);

          onUploadSuccess(type, key);
        }),
      );

      // 3. Send URL to parent
    } catch (err) {
      console.log("upload error");
      console.log(err);
      console.log(err.response);
      console.log(err.response?.data);
    }

    setUploading(false);
    e.target.value = null;
  };

  const removeImage = () => {
    setPreview(null);
    onUploadSuccess(type, null);

    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  return (
    <div className="profile-pic-upload image-field">
     <div className="custom-upload-wrapper">
        <input
          ref={fileInputRef}
          type="file"
          accept=".jpg,.jpeg,.png"
          id={type + "Input"}
          className="d-none"
          onChange={handleImageUpload}
        />

        <label
          htmlFor={type + "Input"}
          className="custom-upload-box"
        >
          {preview ? (
            <>
              <img
                src={preview}
                alt={type}
                className="custom-upload-image"
              />

              <button
                type="button"
                className="custom-remove-btn"
                onClick={(e) => {
                  e.preventDefault();
                  removeImage();
                }}
              >
                ×
              </button>
            </>
          ) : (
            <div className="upload-placeholder">
              <i className="fas fa-cloud-upload-alt"></i>

              <h6   className="text-dark">Upload Reference Design</h6>

              <p className="text-dark">
                JPG, PNG, JPEG
                <br />
                Max Size 2MB
              </p>
            </div>
          )}
        </label>
      </div>
    </div>
  );
}

export default ImageUploader;